var $e1f7e61e53a5834c$exports = {};
$e1f7e61e53a5834c$exports = {
    "pending": `in behandeling`
};


export {$e1f7e61e53a5834c$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
